import React from 'react';
import { observer } from 'mobx-react';
import { formulaLabelsConfig } from './Formula.labels.config';
import { FormulaInput, FormulaRadioGroup } from '../FormulaInput/FormulaInput';
import './Formula.scss';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';

const FormulaContentComponent = (props) => {
  const vm = props.vm;
  return ( 
    <div>
      <div className="formula-inputs float-left">
        <div className="formula-inputs-set">
          {!vm.formulaProps.noNvalue || vm.props === "circular-section"? (
            <span className="input-help-header">
              {vm.props === "parabolic-channel" && <span>Not for Grassed Waterway Design</span>}
                <a
                  target="_blank"
                  href="https://usdagcc.sharepoint.com/sites/FPAC-NRCS-EngineeringPlanningAnalysisandDesignSoftwareEPAD/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FFPAC%2DNRCS%2DEngineeringPlanningAnalysisandDesignSoftwareEPAD%2FShared%20Documents%2FGeneral%2FNETS%2DSupport%20Documents%2FFormulas%20Documentation%2FHelp%20Select%20n%20Value%2Epdf&parent=%2Fsites%2FFPAC%2DNRCS%2DEngineeringPlanningAnalysisandDesignSoftwareEPAD%2FShared%20Documents%2FGeneral%2FNETS%2DSupport%20Documents%2FFormulas%20Documentation"
                >
                  Help select n value 
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              
            </span>
          ):null}

          {/* Tabs */}
          {vm.tabs.length > 0 ? (
            <>
              <FormulaRadioGroup
                label="Specify"
                labelClassName="sections-heading"
                labelId="orifice-radio"
                items={vm.tabs}
              />

              {Object.keys(vm.formData)
                .filter((el) => formulaLabelsConfig[el].tab)
                .map((key) => (
                  <FormulaFormTabPaneElement
                    key={`tabPane-${key}`}
                    formData={vm.formData}
                    elementKey={key}
                    formHasError={vm.formValidation.hasError}
                    formValidation={vm.formValidation}
                    handleInputChange={vm.handleInputChange}
                    activeTab={vm.activeTab}
                  />
                ))}
            </>
          ) : null}
          {vm.props !== "rectangular-riser-drop" && <h2 className="sections-heading">General</h2>}
         
          {vm.formData &&
            Object.keys(vm.formData).map((key) => (
              <FormulaFormElement
                key={`form-field-top-level-${key}`}
                formData={vm.formData}
                elementKey={key}
                formHasError={vm.formValidation.hasError}
                formValidation={vm.formValidation}
                handleInputChange={vm.handleInputChange}
                onBlur={vm.handleInputFocus}
                formulaTitle={vm.formulaTitle}
              />
            ))}
        </div>

        <div className="formula-buttons ">
          <div></div>
          <div className="nobr">
            <button
              className="usa-button"
              data-testid="compute-button"
              onClick={vm.onClickComputeFormula}
              disabled={vm.isLoading}
            >
              Compute
            </button>
            <button
              className="usa-button"
              data-testid="input-container-button"
              onClick={vm.launchAndExport}
              disabled={!vm.hasResults}
            >
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export const FormulaContent = observer(FormulaContentComponent);

// formHasError needed to update input valid/invalid
const FormulaFormElement = observer(
  ({ formData, elementKey, formHasError, formValidation, handleInputChange, onBlur, formulaTitle }) =>{

  return(
    formData[elementKey] instanceof Object ? (
      formulaLabelsConfig[elementKey] && formulaLabelsConfig[elementKey].tab ? null : (
        <>
          <h2 className="sections-heading">
            {formulaLabelsConfig[elementKey] ? formulaLabelsConfig[elementKey].label : elementKey}
          </h2>
          {formData[elementKey] &&
            Object.keys(formData[elementKey]).map((k) => (
              <FormulaInput
                key={`formula-input-${k}`}
                k={k}
                valid={!formValidation[k]}
                value={formData[elementKey][k]}
                onChange={(e) => handleInputChange(e, elementKey)}
                onBlur={(e)=>onBlur(e,elementKey)}
                formula={formulaTitle}
              />
            ))}
        </>
      )
    ) : (
      <FormulaInput
        k={elementKey}
        valid={!formValidation[elementKey]}
        value={formData[elementKey]}
        onChange={handleInputChange}
        onBlur={onBlur}
        formula={formulaTitle}
      />
    )
  )}
);

// formHasError needed to update input valid/invalid
const FormulaFormTabPaneElement = observer(
  ({ formData, elementKey, formValidation, formHasError, handleInputChange, activeTab }) =>
    activeTab === elementKey &&
    formData[elementKey] &&
    Object.keys(formData[elementKey]).map((k) => (
      <FormulaInput
        key={`formula-input-${k}`}
        k={k}
        valid={!formValidation[k]}
        value={formData[elementKey][k]}
        onChange={(e) => handleInputChange(e, elementKey)}
      />
    ))
);
